import React, { useState, useEffect, useRef } from 'react'
import { Html, useAspect } from '@react-three/drei'
import { Dimensions } from 'react-native'
import { useThree } from '@react-three/fiber'
import { useEvents } from '../../systems/World/hooks'
import { GAME_EVENTS } from '../../systems/World/Events'
import anime from '../../helpers/anime';

const CountDown = () => {
  const [count, setCount] = useState()
  const [start, setStart] = useState()
  const gameReadyTrigger = useEvents(GAME_EVENTS.READY_ON)
  const systemOnlineTrigger = useEvents(GAME_EVENTS.SYSTEM_ONLINE)
  const { camera } = useThree()
  const tId = useRef()
  useEffect(() => {
    if (count === 0) {
      gameReadyTrigger()
    } else {
      if (count !== undefined) {
        tId.current = setTimeout(() => {
          setCount(count - 1)
        }, 750)
      }
    }
    () => {
      clearTimeout(tId.current)
    }
  }, [count])
  useEffect(() => {
    if (!start) return
    const destination = { x: -5, y: 11, z: 20 } //{...camera.position}
    camera.position.x = -3
    camera.position.y = -15
    camera.position.z = 10
    camera.lookAt(0, 0, 3)
    const targetObj = { ...camera.position }
    anime({
      easing: Math.random() > 0.5 ? 'easeInOutExpo' : 'easeInOutBack',
      duration: 6000,
      x: destination.x,
      y: destination.y,
      z: destination.z,
      targets: targetObj,
      update: function () {
        camera.position.x = targetObj.x
        camera.position.y = targetObj.y
        camera.position.z = targetObj.z
        camera.lookAt(0, 0, 3)
      },
      complete: function () {
        setCount(3)
      }
    })
  }, [start])
  useEffect(() => {
    setTimeout(() => {
      systemOnlineTrigger()
      setStart(true)
    }, 2000)
  }, [camera])
  const width = Dimensions.get("window").width > 900 ? 900 : Dimensions.get("window").width
  const height = Dimensions.get("window").height > 400 ? 400 : Dimensions.get("window").height
  
  const scale = useAspect(
    "cover",
    width,
    height,
    1
  )
  return (
    count > 0 &&
    <Html scaleFactor={scale}
      calculatePosition={() => [0, 0, 0]}
      style={{
          // backgroundColor: '#0f0a',
          minWidth: width,
          minHeight: height
        }}
    // position={[-scale.width, 0, -scale.height]}
    >
      { count !== 0 &&
        <div
          className="content"
          style={{
            // border: '1px solid red',
            // backgroundColor: '#f00a',
            display: 'flex',
            color: 'white',
            fontFamily: 'Arial',
            fontWeight: 'bold',
            flexBasis: '100%',
            width: '100%',
            height: '100%',
            minWidth: '100%',
            minHeight: '100%',
            boxSizing: 'border-box',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <span style={{ fontSize: 180 }}>{count}</span>
        </div>
      }
    </Html>
  )
}
export default CountDown